<div nz-row>
  <div nz-col nzSpan="24" style="margin-bottom: 1rem;" class="no-form">
    <h1 i18n="Identity.EditIdentity.Title|title for edit identity page@@Identity.EditIdentity.Title">Gestione identità
    </h1>
  </div>
</div>
<div nz-row>
  <div nz-col class="data-column no-form" nzSpan="24">
    <div class="data-box">
      <span class="data-type">Username</span>
      <span class="data-value">{{user.username}}</span>
    </div>
  </div>
  <div nz-col class="data-column no-form" nzSpan="24">
    <div class="data-box">
      <span class="data-type">E-mail</span>
      <span class="data-value">{{user.email}}<a nz-button nzType="link" class="inner-cta"
          (click)="onEditEmail(emailModal, emailModalFooter)">Modifica</a></span>
    </div>
  </div>
  <div nz-col class="data-column no-form" nzSpan="24">
    <div class="data-box">
      <span class="data-type">Cellulare</span>
      <span class="data-value">{{user.phone_number}}<a nz-button nzType="link" class="inner-cta"
          (click)="onEditMobile(mobileModal, mobileModalFooter)">Modifica</a></span>
    </div>
  </div>
  <div nz-col class="data-column no-form" nzSpan="24">
    <div class="data-box">
      <span class="data-type">Documento di riconoscimento</span>
      <span class="data-value">{{user.identityDocument.document_type}}, {{user.identityDocument.document_number}}<a
          nz-button nzType="link" class="inner-cta"
          (click)="onEditDocument(documentModal, documentModalFooter)">Modifica</a></span>
    </div>
  </div>
  <div nz-col class="data-column no-form" nzSpan="24">
    <div class="data-box">
      <span class="data-type">Domicilio</span>
      <span class="data-value">{{user.legalAddress.address}}, {{user.legalAddress.city}}
        ({{user.legalAddress.country}})<a nz-button nzType="link" class="inner-cta"
          (click)="onEditAddress(addressModal, addressModalFooter)">Modifica</a></span>
    </div>
  </div>
  <div nz-col class="data-column no-form" nzSpan="24">
    <div class="data-box">
      <span class="data-type">Domicilio digitale</span>
      <span class="data-value">{{user.pec}}
        <a nz-button nzType="link" class="inner-cta"
          (click)="onEditDigitalAddress(digitalAddressModal, digitalAddressModalFooter)">Modifica</a>
      </span>
    </div>
  </div>
  <div *ngIf="user.company" nz-col class="data-column no-form" nzSpan="24">
    <div class="data-box">
      <span class="data-type">Organizzazione</span>
      <span class="data-value">{{user.company.name}}
        <!-- <a nz-button nzType="link" class="inner-cta"
          (click)="onEditCompany(companyModal, companyModalFooter)">Modifica</a> -->
      </span>
    </div>
  </div>
  <!-- <div nz-col class="data-column no-form" nzSpan="24">
      <div class="data-box">
        <span class="data-type">Codice di emergenza</span>
        <span class="data-value"> <a nz-button nzType="link" class="inner-cta"
            (click)="onRecoveryEmergencyCode()">Recupera</a></span>
      </div>
    </div> -->
</div>

<ng-template #digitalAddressModal let-params let-ref="modalRef">
  <span class="textEditIdentity"
    i18n="Identity.EditIdentity.ModalDescription|description for modal in edit identity@@Identity.EditIdentity.ModalDescription">Inserisci
    nei campi sottostanti il nuovo dato e il codice OTP ricevuto tramite SMS al numero rilasciato in fase
    di registrazione per completare</span>
  <nz-spin nzTip="Invio richiesta..." [nzSpinning]="isSpinning">
    <form autocomplete="off" nz-form class="custom-form" [formGroup]="modifyDigitalAddressForm">
      <nz-form-item>
        <div nz-row>
          <div nz-col nzSpan="24" class="no-form">
            <nz-form-control nzHasFeedback
              [nzErrorTip]="getValidationErrorMessage(modifyDigitalAddressForm.controls.addressChange.errors)">
              <nz-input-group nzPrefixIcon="mail" class="login">
                <input nz-input name="address" placeholder="Indirizzo digitale" formControlName="addressChange">
              </nz-input-group>
            </nz-form-control>
          </div>
        </div>
      </nz-form-item>
      <app-resend-otp class="withPadding"
        [disabled]="!modifyDigitalAddressForm.controls.addressChange.valid || timerService.otpSended"
        [validateForm]="modifyDigitalAddressForm"
        [errorTip]="getValidationErrorMessage(modifyDigitalAddressForm.controls.otpCode.errors)"
        (isSpinning)="activateSpin($event)"
      ></app-resend-otp>
    </form>
  </nz-spin>
</ng-template>
<ng-template #digitalAddressModalFooter>
  <button nz-button nzType="primary" (click)="onSendDigitalAddressChange()" [nzLoading]="isSpinning"
    [disabled]="!modifyDigitalAddressForm.valid">INVIA</button>
</ng-template>

<ng-template #companyModal let-params let-ref="modalRef">
  <span class="textEditIdentity"
    i18n="Identity.EditIdentity.ModalDescription|description for modal in edit identity@@Identity.EditIdentity.ModalDescription">Inserisci
    nei campi sottostanti il nuovo dato e il codice OTP ricevuto tramite SMS al numero rilasciato in fase
    di registrazione per completare</span>
  <nz-spin nzTip="Invio richiesta..." [nzSpinning]="isSpinning">
    <form autocomplete="off" nz-form class="custom-form" [formGroup]="modifyCompanyForm">
      <nz-form-item>
        <div nz-row>
          <div nz-col nzSpan="24" class="no-form">
            <nz-form-control nzHasFeedback
              [nzErrorTip]="getValidationErrorMessage(modifyCompanyForm.controls.address_type.errors)">
              <nz-input-group nzPrefixIcon="mail" class="login">
                <input nz-input name="address_type" placeholder="Tipo Indirizzo" formControlName="address_type">
              </nz-input-group>
            </nz-form-control>
          </div>
        </div>
      </nz-form-item>
      <nz-form-item>
        <div nz-row>
          <div nz-col nzSpan="24" class="no-form">
            <nz-form-control nzHasFeedback
              [nzErrorTip]="getValidationErrorMessage(modifyCompanyForm.controls.address_name.errors)">
              <nz-input-group nzPrefixIcon="mail" class="login">
                <input nz-input name="address_name" placeholder="Indirizzo" formControlName="address_name">
              </nz-input-group>
            </nz-form-control>
          </div>
        </div>
      </nz-form-item>
      <nz-form-item>
        <div nz-row>
          <div nz-col nzSpan="24" class="no-form">
            <nz-form-control nzHasFeedback
              [nzErrorTip]="getValidationErrorMessage(modifyCompanyForm.controls.address_num.errors)">
              <nz-input-group nzPrefixIcon="mail" class="login">
                <input nz-input name="address_num" placeholder="Civico" formControlName="address_num">
              </nz-input-group>
            </nz-form-control>
          </div>
        </div>
      </nz-form-item>
      <nz-form-item>
        <div nz-row>
          <div nz-col nzSpan="24" class="no-form">
            <nz-form-control nzHasFeedback
              [nzErrorTip]="getValidationErrorMessage(modifyCompanyForm.controls.postal_code.errors)">
              <nz-input-group nzPrefixIcon="mail" class="login">
                <input nz-input name="postal_code" placeholder="CAP" formControlName="postal_code">
              </nz-input-group>
            </nz-form-control>
          </div>
        </div>
      </nz-form-item>
      <nz-form-item>
        <div nz-row>
          <div nz-col nzSpan="24" class="no-form">
            <nz-form-control nzHasFeedback
              [nzErrorTip]="getValidationErrorMessage(modifyCompanyForm.controls.city.errors)">
              <nz-input-group nzPrefixIcon="mail" class="login">
                <input nz-input name="city" placeholder="Città" formControlName="city">
              </nz-input-group>
            </nz-form-control>
          </div>
        </div>
      </nz-form-item>
      <nz-form-item>
        <div nz-row>
          <div nz-col nzSpan="24" class="no-form">
            <nz-form-control nzHasFeedback
              [nzErrorTip]="getValidationErrorMessage(modifyCompanyForm.controls.province.errors)">
              <nz-input-group nzPrefixIcon="mail" class="login">
                <input nz-input name="province" placeholder="Provincia" formControlName="province">
              </nz-input-group>
            </nz-form-control>
          </div>
        </div>
      </nz-form-item>
      <nz-form-item>
        <div nz-row>
          <div nz-col nzSpan="24" class="no-form">
            <nz-form-control nzHasFeedback
              [nzErrorTip]="getValidationErrorMessage(modifyCompanyForm.controls.country.errors)">
              <nz-input-group nzPrefixIcon="mail" class="login">
                <input nz-input name="country" placeholder="Stato" formControlName="country">
              </nz-input-group>
            </nz-form-control>
          </div>
        </div>
      </nz-form-item>
      <app-resend-otp class="withPadding"
        [disabled]="timerService.otpSended"
        [validateForm]="modifyCompanyForm"
        [errorTip]="getValidationErrorMessage(modifyCompanyForm.controls.otpCode.errors)"
        (isSpinning)="activateSpin($event)"
      ></app-resend-otp>
    </form>
  </nz-spin>
</ng-template>
<ng-template #companyModalFooter>
  <button nz-button nzType="primary" (click)="onSendCompanyChange()" [nzLoading]="isSpinning"
    [disabled]="!modifyCompanyForm.valid">INVIA</button>
</ng-template>

<ng-template #addressModal let-params let-ref="modalRef">
  <span class="textEditIdentity"
    i18n="Identity.EditIdentity.ModalDescription|description for modal in edit identity@@Identity.EditIdentity.ModalDescription">Inserisci
    nei campi sottostanti il nuovo dato e il codice OTP ricevuto tramite SMS al numero rilasciato in fase
    di registrazione per completare</span>
  <nz-spin nzTip="Invio richiesta..." [nzSpinning]="isSpinning">
    <form autocomplete="off" nz-form class="custom-form" [formGroup]="modifyAddressForm">
      <nz-form-item>
        <div nz-row>
          <div nz-col nzSpan="24" class="no-form">
            <nz-form-control nzHasFeedback
              [nzErrorTip]="getValidationErrorMessage(modifyAddressForm.controls.addressTypeChange.errors)">
              <nz-input-group nzPrefixIcon="environment" class="login">
                <nz-select nzShowSearch nzAllowClear name="address_type" nzPlaceHolder="Tipo Indirizzo"
                  formControlName="addressTypeChange">
                  <nz-option *ngFor="let type of addressTypeChoices" [nzLabel]="type.label" [nzValue]="type.key">
                  </nz-option>
                </nz-select>
              </nz-input-group>
            </nz-form-control>
          </div>
        </div>
      </nz-form-item>
      <nz-form-item>
        <div nz-row>
          <div nz-col nzSpan="24" class="no-form">
            <nz-form-control nzHasFeedback
              [nzErrorTip]="getValidationErrorMessage(modifyAddressForm.controls.addressNameChange.errors)">
              <nz-input-group nzPrefixIcon="environment" class="login">
                <input nz-input name="address" placeholder="Indirizzo" formControlName="addressNameChange">
              </nz-input-group>
            </nz-form-control>
          </div>
        </div>
      </nz-form-item>
      <nz-form-item>
        <div nz-row>
          <div nz-col nzSpan="24" class="no-form">
            <nz-form-control nzHasFeedback
              [nzErrorTip]="getValidationErrorMessage(modifyAddressForm.controls.addressNumChange.errors)">
              <nz-input-group nzPrefixIcon="environment" class="login">
                <input nz-input name="address_num" placeholder="Civico" formControlName="addressNumChange">
              </nz-input-group>
            </nz-form-control>
          </div>
        </div>
      </nz-form-item>
      <nz-form-item>
        <div nz-row>
          <div nz-col nzSpan="24" class="no-form">
            <nz-form-control nzHasFeedback
              [nzErrorTip]="getValidationErrorMessage(modifyAddressForm.controls.capChange.errors)">
              <nz-input-group nzPrefixIcon="environment" class="login">
                <input nz-input name="cap" placeholder="CAP" formControlName="capChange">
              </nz-input-group>
            </nz-form-control>
          </div>
        </div>
      </nz-form-item>
      <nz-form-item>
        <div nz-row>
          <div nz-col nzSpan="24" class="no-form">
            <nz-form-control nzHasFeedback
              [nzErrorTip]="getValidationErrorMessage(modifyAddressForm.controls.countryChange.errors)">
              <nz-input-group nzPrefixIcon="environment" class="login">
                <nz-select
                  name="country"
                  formControlName="countryChange"
                  [nzShowArrow]="false"
                  nzShowSearch
                  nzServerSearch
                  nzPlaceHolder="Stato"
                  [nzFilterOption]="nzFilterOption"
                  (nzOnSearch)="lookUpCountries($event)"
                  (nzScrollToBottom)="loadMoreCountries()"
                >
                  <ng-container *ngIf="!(areLoadingCountries$ | async)">
                    <nz-option *ngFor="let country of countries$ | async" [nzLabel]="country.text" [nzValue]="country.id"></nz-option>
                  </ng-container>
                  <nz-option nzDisabled nzCustomContent *ngIf="showCountrySpinner$ | async">
                    <span nz-icon nzType="loading" class="loading-icon"></span>
                    Carico...
                  </nz-option>
                </nz-select>
              </nz-input-group>
            </nz-form-control>
          </div>
        </div>
      </nz-form-item>
      <nz-form-item>
        <div nz-row>
          <div nz-col nzSpan="24" class="no-form">
            <nz-form-control nzHasFeedback
              [nzErrorTip]="getValidationErrorMessage(modifyAddressForm.controls.provinceChange.errors)">
              <nz-input-group nzPrefixIcon="environment" class="login">
                <nz-select
                  name="province"
                  formControlName="provinceChange"
                  [nzShowArrow]="false"
                  nzShowSearch
                  nzServerSearch
                  nzPlaceHolder="Provincia"
                  [nzFilterOption]="nzFilterOption"
                  (nzOnSearch)="lookUpProvinces($event)"
                  (nzScrollToBottom)="loadMoreProvincies()"
                >
                  <ng-container *ngIf="!(areLoadingProvincies$ | async)">
                    <nz-option *ngFor="let province of provincies$ | async" [nzLabel]="province.text" [nzValue]="province.id"></nz-option>
                  </ng-container>
                  <nz-option nzDisabled nzCustomContent *ngIf="showProvinceSpinner$ | async">
                    <span nz-icon nzType="loading" class="loading-icon"></span>
                    Carico...
                  </nz-option>
                </nz-select>
              </nz-input-group>
            </nz-form-control>
          </div>
        </div>
      </nz-form-item>
      <nz-form-item>
        <div nz-row>
          <div nz-col nzSpan="24" class="no-form">
            <nz-form-control nzHasFeedback
              [nzErrorTip]="getValidationErrorMessage(modifyAddressForm.controls.cityChange.errors)">
              <nz-input-group nzPrefixIcon="environment" class="login">
                <nz-select
                  name="city"
                  formControlName="cityChange"
                  [nzShowArrow]="false"
                  nzShowSearch
                  nzServerSearch
                  nzPlaceHolder="Città"
                  [nzFilterOption]="nzFilterOption"
                  (nzOnSearch)="lookUpCities($event)"
                  (nzScrollToBottom)="loadMoreCities()"
                >
                  <ng-container *ngIf="!(areLoadingCities$ | async)">
                    <nz-option *ngFor="let city of cities$ | async" [nzLabel]="city.text" [nzValue]="city.id"></nz-option>
                  </ng-container>
                  <nz-option nzDisabled nzCustomContent *ngIf="showCitySpinner$ | async">
                    <span nz-icon nzType="loading" class="loading-icon"></span>
                    Carico...
                  </nz-option>
                </nz-select>
              </nz-input-group>
            </nz-form-control>
          </div>
        </div>
      </nz-form-item>
      <app-resend-otp class="withPadding"
        [disabled]="
          timerService.otpSended || !modifyAddressForm.controls.addressTypeChange.valid || !modifyAddressForm.controls.addressNameChange.valid ||
          !modifyAddressForm.controls.addressNumChange.valid || !modifyAddressForm.controls.capChange.valid ||
          !modifyAddressForm.controls.cityChange.valid || !modifyAddressForm.controls.provinceChange.valid ||
          !modifyAddressForm.controls.countryChange.valid
        "
        [validateForm]="modifyAddressForm"
        [errorTip]="getValidationErrorMessage(modifyAddressForm.controls.otpCode.errors)"
        (isSpinning)="activateSpin($event)"
      ></app-resend-otp>
    </form>
  </nz-spin>
</ng-template>
<ng-template #addressModalFooter>
  <button nz-button nzType="primary" (click)="onSendAddressChange()" [nzLoading]="isSpinning"
    [disabled]="!modifyAddressForm.valid">INVIA</button>
</ng-template>

<ng-template #documentModal let-params let-ref="modalRef">
  <span class="textEditIdentity"
    i18n="Identity.EditIdentity.ModalDescription|description for modal in edit identity@@Identity.EditIdentity.ModalDescription">Inserisci
    nei campi sottostanti il nuovo dato e il codice OTP ricevuto tramite SMS al numero rilasciato in fase
    di registrazione per completare</span>
  <nz-spin nzTip="Invio richiesta..." [nzSpinning]="isSpinning">
    <form autocomplete="off" nz-form class="custom-form" [formGroup]="modifyDocumentForm">
      <nz-form-item>
        <div nz-row>
          <div nz-col nzSpan="12" class="no-form">
            <nz-form-label>
              Tipologia Documento
            </nz-form-label>
          </div>
          <div nz-col nzSpan="12" class="no-form">
            <nz-form-control nzHasFeedback
              [nzErrorTip]="getValidationErrorMessage(modifyDocumentForm.controls.document_typeChange.errors)">
              <nz-select id="document_typeChange" formControlName="document_typeChange"
                nzPlaceHolder="Tipologia Documento">
                <nz-option nzValue="IC" nzLabel="Carta d'identità"></nz-option>
                <nz-option nzValue="PS" nzLabel="Passaporto"></nz-option>
                <nz-option nzValue="DL" nzLabel="Patente"></nz-option>

              </nz-select>
            </nz-form-control>
          </div>
        </div>
      </nz-form-item>
      <nz-form-item>
        <div nz-row>
          <div nz-col nzSpan="12" class="no-form">

            <nz-form-label>
              Tipologia Ente di Rilascio
            </nz-form-label>
          </div>
          <div nz-col nzSpan="12" class="no-form">
            <nz-form-control nzHasFeedback
              [nzErrorTip]="getValidationErrorMessage(modifyDocumentForm.controls.issuerTypeChange.errors)">
              <nz-select id="issuerTypeChange" formControlName="issuerTypeChange" nzPlaceHolder="Ente di Rilascio">
                <nz-option nzValue="COMUNE" nzLabel="Comune"></nz-option>
                <nz-option nzValue="QUESTURA" nzLabel="Questura"></nz-option>
                <nz-option nzValue="MCTC" nzLabel="Motorizzazione Civile"></nz-option>
                <nz-option nzValue="MIT" nzLabel="Ministero delle Infrastrutture e dei Trasporti"></nz-option>
                <nz-option nzValue="MIT_UCO"
                  nzLabel="Ufficio Centrale Operativo del Ministero delle Infrastrutture e dei Trasporti"></nz-option>
                <nz-option nzValue="MAECI" nzLabel="Ministero degli Affari esteri e della Cooperazione internazionale">
                </nz-option>
                <nz-option nzValue="CONSOLATO" nzLabel="Consolato Generale d\'Italia"></nz-option>
                <nz-option nzValue="AMBASCIATA" nzLabel="Ambasciata"></nz-option>
                <nz-option nzValue="COMUNE" nzLabel="Comune"></nz-option>
                <nz-option nzValue="PREFETTURA" nzLabel="Prefettura"></nz-option>
              </nz-select>
            </nz-form-control>
          </div>
        </div>
      </nz-form-item>
      <nz-form-item>
        <div nz-row>
          <div nz-col nzSpan="24" class="no-form">
            <nz-form-control
              nzHasFeedback
              [nzErrorTip]="getValidationErrorMessage(modifyDocumentForm.controls.issuerNameChange.errors)"
            >
              <nz-input-group nzPrefixIcon="idcard" class="login">
                <nz-select
                  name="issuerNameChange"
                  formControlName="issuerNameChange"
                  [nzShowArrow]="false"
                  nzShowSearch
                  nzServerSearch
                  nzPlaceHolder="Nome Ente rilasciante"
                  [nzFilterOption]="nzFilterOption"
                  (nzOnSearch)="lookUpNameDocument($event)"
                  (nzScrollToBottom)="loadMoreIssuer()"
                >
                  <ng-container *ngIf="!(areLoadingIssuers$ | async)">
                    <nz-option
                      *ngFor="let issuer of (issuers$ | async)"
                      [nzValue]="issuer.id"
                      [nzLabel]="issuer.text"
                    ></nz-option>
                  </ng-container>
                  <nz-option nzDisabled nzCustomContent *ngIf="showIssuerSpinner$ | async">
                    <span nz-icon nzType="loading" class="loading-icon"></span>
                    Carico...
                  </nz-option>
                </nz-select>
              </nz-input-group>
            </nz-form-control>
          </div>
        </div>
      </nz-form-item>
      <nz-form-item>
        <div nz-row>
          <div nz-col nzSpan="24" class="no-form">
            <nz-form-control nzHasFeedback
              [nzErrorTip]="getValidationErrorMessage(modifyDocumentForm.controls.issueCountryChange.errors)">
              <nz-input-group nzPrefixIcon="idcard" class="login">
                <input nz-input name="issueCountryChange" placeholder="Nazionalità Ente rilasciante"
                  formControlName="issueCountryChange">
              </nz-input-group>
            </nz-form-control>
          </div>
        </div>
      </nz-form-item>
      <nz-form-item>
        <div nz-row>
          <div nz-col nzSpan="24" class="no-form">
            <nz-form-control nzHasFeedback
              [nzErrorTip]="getValidationErrorMessage(modifyDocumentForm.controls.document_numberChange.errors)">
              <nz-input-group nzPrefixIcon="idcard" class="login">
                <input nz-input name="number" placeholder="Numero Documento" formControlName="document_numberChange">
              </nz-input-group>
            </nz-form-control>
          </div>
        </div>
      </nz-form-item>
      <nz-form-item>
        <div nz-row>
          <div nz-col nzSpan="12" class="no-form">
            <nz-form-label
              i18n="Identity.EditIdentity.FormDocIssueDate|label for form - document issue date@@Identity.EditIdentity.FormDocIssueDate">
              Data di rilascio
            </nz-form-label>
          </div>
          <div nz-col nzSpan="12" class="no-form">
            <nz-form-control nzHasFeedback
              [nzErrorTip]="getValidationErrorMessage(modifyDocumentForm.controls.issueDateChange.errors)">

              <nz-date-picker nzFormat="dd/MM/yyyy" [nzDisabledDate]="disabledFutureDate" name="issueDate"
                placeholder="Data di rilascio" formControlName="issueDateChange">
              </nz-date-picker>

            </nz-form-control>
          </div>
        </div>
      </nz-form-item>
      <nz-form-item>
        <div nz-row>
          <div nz-col nzSpan="12" class="no-form">
            <nz-form-label
              i18n="Identity.EditIdentity.FormDocdocument_expiration_date|label for form - document expire date@@Identity.EditIdentity.FormDocdocument_expiration_date">
              Data di scadenza
            </nz-form-label>
          </div>
          <div nz-col nzSpan="12" class="no-form">
            <nz-form-control nzHasFeedback
              [nzErrorTip]="getValidationErrorMessage(modifyDocumentForm.controls.document_expiration_dateChange.errors)">

              <nz-date-picker nzFormat="dd/MM/yyyy" [nzDisabledDate]="disabledPastDate" name="type"
                placeholder="Data di scadenza" formControlName="document_expiration_dateChange">
              </nz-date-picker>

            </nz-form-control>
          </div>
        </div>
      </nz-form-item>
      <app-resend-otp class="withPadding"
        [disabled]="
          timerService.otpSended || !modifyDocumentForm.controls.document_typeChange.valid || !modifyDocumentForm.controls.document_numberChange.valid || !modifyDocumentForm.controls.document_expiration_dateChange.valid ||
          !modifyDocumentForm.controls.issueDateChange.valid || !modifyDocumentForm.controls.issuerNameChange.valid || !modifyDocumentForm.controls.issuerTypeChange.valid ||
          !modifyDocumentForm.controls.document_expiration_dateChange.valid || !modifyDocumentForm.controls.issueCountryChange.valid
        "
        [validateForm]="modifyDocumentForm"
        [errorTip]="getValidationErrorMessage(modifyDocumentForm.controls.otpCode.errors)"
        (isSpinning)="activateSpin($event)"
      ></app-resend-otp>
    </form>
  </nz-spin>
</ng-template>
<ng-template #documentModalFooter>
  <button nz-button nzType="primary" (click)="onSendDocumentChange()" [nzLoading]="isSpinning"
    [disabled]="!modifyDocumentForm.valid">INVIA</button>
</ng-template>

<ng-template #emailModal let-params let-ref="modalRef">
  <span class="textEditIdentity"
    i18n="Identity.EditIdentity.ModalDescription|description for modal in edit identity@@Identity.EditIdentity.ModalDescription">Inserisci
    nei campi sottostanti il nuovo dato e il codice OTP ricevuto tramite SMS al numero rilasciato in fase
    di registrazione per completare. Al termine della procedura sarà inviata una e-mail per la conferma all'indirizzo
    specificato.</span>
  <nz-spin nzTip="Invio richiesta..." [nzSpinning]="isSpinning">
    <form autocomplete="off" nz-form class="custom-form" [formGroup]="modifyEmailForm">
      <nz-form-item>
        <div nz-row>
          <div nz-col nzSpan="24" class="no-form">
            <nz-form-control nzHasFeedback [nzValidateStatus]="emailChange"
              [nzErrorTip]="getValidationErrorMessage(modifyEmailForm.controls.emailChange.errors)">
              <nz-input-group nzPrefixIcon="mail" class="login">
                <input nz-input name="email" placeholder="Nuova e-mail" formControlName="emailChange">
              </nz-input-group>
            </nz-form-control>
          </div>
        </div>
      </nz-form-item>
      <nz-form-item>
        <div nz-row>
          <div nz-col nzSpan="24" class="no-form">
            <nz-form-control nzHasFeedback [nzValidateStatus]="emailChangeConfirm"
              [nzErrorTip]="getValidationErrorMessage(modifyEmailForm.controls.emailChangeConfirm.errors)">
              <nz-input-group nzPrefixIcon="mail" class="login">
                <input nz-input name="email" placeholder="Conferma nuova e-mail" formControlName="emailChangeConfirm">
              </nz-input-group>
              <div *ngIf="modifyEmailForm.errors?.emailsDontMatch && (modifyEmailForm.touched || modifyEmailForm.dirty)"
                class="cross-validation-error-message alert alert-danger"
                i18n="Generic.ValidationError.EmailsDontMatch|Errore che si ha quando viene chiesto di digitare due volte l'email e queste sono diverse@@Generic.ValidationError.EmailsDontMatch">
                Le email devono coincidere
              </div>
            </nz-form-control>
          </div>
        </div>
      </nz-form-item>
      <app-resend-otp class="withPadding"
        [disabled]="!modifyEmailForm.controls.emailChangeConfirm.valid || !modifyEmailForm.controls.emailChange.valid || timerService.otpSended || modifyEmailForm.errors?.emailsDontMatch"
        [validateForm]="modifyEmailForm"
        [errorTip]="getValidationErrorMessage(modifyEmailForm.controls.otpCode.errors)"
        (isSpinning)="activateSpin($event)"
      ></app-resend-otp>
    </form>
  </nz-spin>
</ng-template>
<ng-template #emailModalFooter>
  <button nz-button nzType="primary" (click)="onSendEmailChange()" [nzLoading]="isSpinning"
    [disabled]="!modifyEmailForm.valid">INVIA</button>
</ng-template>

<ng-template #mobileModal let-params let-ref="modalRef">
  <span class="textEditIdentity"
    i18n="Identity.EditIdentity.ModalDescription|description for modal in edit identity@@Identity.EditIdentity.ModalDescription">Inserisci
    nei campi sottostanti il nuovo dato e il codice OTP ricevuto tramite SMS al numero rilasciato in fase
    di registrazione per completare </span>
  <nz-spin nzTip="Invio richiesta..." [nzSpinning]="isSpinning">
    <form autocomplete="off" nz-form class="custom-form" [formGroup]="modifyMobileForm">
      <nz-form-item class="login">
        <div nz-row>
          <p style="margin-bottom: 0px;">Nuovo numero di cellulare</p>
          <div nz-col nzSpan="24">
            <nz-form-control nzHasFeedback [nzValidateStatus]="mobileChange"
              [nzErrorTip]="getValidationErrorMessage(modifyMobileForm.controls.mobileChange.errors)">
                <input ng2TelInput class="phoneForm"
                  (countryChange)="onCountryChange(true, $event)" (ngModelChange)="onValidatePhone()"
                  (intlTelInputObject)="telInputObject(true, $event)"
                  [ng2TelInputOptions]="{initialCountry: 'it', nationalMode: false, autoHideDialCode: false, formatOnDisplay: false}"
                  autocomplete="off" name="mobileChange" formControlName="mobileChange" placeholder="Nuovo numero di cellulare"/>
            </nz-form-control>
          </div>
        </div>
      </nz-form-item>
      <nz-form-item class="login">
        <div nz-row>
          <p style="margin-bottom: 0px;">Conferma il numero</p>
          <div nz-col nzSpan="24" style="width: 100%;">
            <nz-form-control nzHasFeedback [nzValidateStatus]="mobileChangeConfirm"
              [nzErrorTip]="getValidationErrorMessage(modifyMobileForm.controls.mobileChangeConfirm.errors)">
                <input ng2TelInput class="phoneForm"
                (countryChange)="onCountryChange(false, $event)" (ngModelChange)="onValidatePhone()"
                (intlTelInputObject)="telInputObject(false, $event)"
                [ng2TelInputOptions]="{initialCountry: 'it', nationalMode: false, autoHideDialCode: false, formatOnDisplay: false}"
                autocomplete="off"  name="mobileChangeConfirm" placeholder="Conferma il numero" formControlName="mobileChangeConfirm"/>
              <div
                *ngIf="modifyMobileForm.errors?.phonesDontMatch && (modifyMobileForm.touched || modifyMobileForm.dirty)"
                class="cross-validation-error-message alert alert-danger"
                i18n="Generic.ValidationError.PhonesDontMatch|Errore che si ha quando viene chiesto di digitare due volte il numero di cellulare e questi sono diversi@@Generic.ValidationError.PhonesDontMatch">
                I numeri devono coincidere
              </div>
            </nz-form-control>
          </div>
        </div>
      </nz-form-item>
      <app-resend-otp class="withPadding"
        [disabled]="!modifyMobileForm.controls.mobileChangeConfirm.valid || !modifyMobileForm.controls.mobileChange.valid || modifyMobileForm.errors?.phonesDontMatch || timerService.otpSended"
        [validateForm]="modifyMobileForm"
        [errorTip]="getValidationErrorMessage(modifyMobileForm.controls.otpCode.errors)"
        [numberSendOtp] = modifyMobileForm.controls.mobileChangeConfirm.value
        (isSpinning)="activateSpin($event)"
      ></app-resend-otp>
    </form>
  </nz-spin>
</ng-template>
<ng-template #mobileModalFooter>
  <button nz-button nzType="primary" (click)="onSendMobileChange()" [nzLoading]="isSpinning"
    [disabled]="!modifyMobileForm.valid">INVIA</button>
</ng-template>

<app-erc-lost-modal-component [events]="onErcLostEventSubject.asObservable()"></app-erc-lost-modal-component>
